var React = require('react');

function ButtonShape02 (props) {
    return React.createElement("svg",props,React.createElement("path",{"className":"st5","d":"M176.58,44.99c1.31-12.59,3.55-25.33-23.64-32.33C135.23,8.1,54.49-2.76,21.61,1.91\n\tC3.81,4.43-2.24,17.84,1.85,39.47C5.27,57.6,8.27,70.13,33.23,73.53c35.5,4.84,82.79,5.44,119.54,0.65\n\tC170.27,71.91,174.91,60.99,176.58,44.99z"}));
}

ButtonShape02.defaultProps = {"viewBox":"0 0 177.89 78.25"};

module.exports = ButtonShape02;

ButtonShape02.default = ButtonShape02;
